export const companyProfile = {
  brandName: 'VEDANSKRIX',
  legalName: 'Vedanskrix Web LLP',
  tagline: 'Empowering Ideas. Enabling Growth.',
  foundedYear: '2023',
  location: 'Vastral, Ahmedabad, Gujarat',
  phone: '+91 8758637022',
  whatsapp: '+91 8758637022',
  primaryEmail: 'vedanskrix@gmail.com',
  secondaryEmail: 'info@vedanskrix.com',
  websiteUrl: 'https://vedanskrix.com',
  registeredAddress:
    'E-106 Akshardham Heights, Opp. Mahesul Bhavan, S.P. Ring Road, Vastral Road, Ahmedabad, Gujarat 382418, India',
  publicActivity: 'Administrative and support service activities',
  designatedPartners: ['Viral Premnath Mishra', 'Vibha Ramakant Pandey']
};

export const homeStats = [
  {
    value: '2023',
    label: 'Public registration year'
  },
  {
    value: '03',
    label: 'Core service categories'
  },
  {
    value: 'Ahmedabad',
    label: 'Registered base in Gujarat'
  },
  {
    value: '02',
    label: 'Designated partners on public filings'
  }
];
